/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const Mechanism = {
  Manual: "manual",
  Cimd: "cimd",
  Dcr: "dcr",
} as const;
export type Mechanism = ClosedEnum<typeof Mechanism>;

/**
 * Optional caller-declared resource/authorization-server consistency hints, not provider-verified RFC 9728 discovery evidence. May be omitted for explicit manual configuration. Matching values do not establish trust, consent, or user access.
 */
export type ResourceMetadata = {
  authorizationServers: Array<string>;
  resource: string;
};

/**
 * Explicit DCR authentication method.
 */
export const PrepareEMARequestBodyTokenEndpointAuthMethod = {
  ClientSecretBasic: "client_secret_basic",
  ClientSecretPost: "client_secret_post",
} as const;
/**
 * Explicit DCR authentication method.
 */
export type PrepareEMARequestBodyTokenEndpointAuthMethod = ClosedEnum<
  typeof PrepareEMARequestBodyTokenEndpointAuthMethod
>;

export type PrepareEMARequestBody = {
  /**
   * Explicit selected client row ID; never inferred.
   */
  clientId?: string | undefined;
  /**
   * Administrator-declared grants, not provider verification.
   */
  confirmGrants?: Array<string> | undefined;
  /**
   * Optimistic binding generation.
   */
  expectedGeneration: number;
  mechanism?: Mechanism | undefined;
  remoteSessionIssuerId: string;
  /**
   * Canonical intended resource URI.
   */
  resource: string;
  /**
   * Optional caller-declared resource/authorization-server consistency hints, not provider-verified RFC 9728 discovery evidence. May be omitted for explicit manual configuration. Matching values do not establish trust, consent, or user access.
   */
  resourceMetadata?: ResourceMetadata | undefined;
  /**
   * Requested scope tokens.
   */
  scopes?: Array<string> | undefined;
  /**
   * Explicit DCR authentication method.
   */
  tokenEndpointAuthMethod?:
    | PrepareEMARequestBodyTokenEndpointAuthMethod
    | undefined;
  userSessionIssuerId: string;
};

/** @internal */
export const Mechanism$outboundSchema: z.ZodMiniEnum<typeof Mechanism> = z.enum(
  Mechanism,
);

/** @internal */
export type ResourceMetadata$Outbound = {
  authorization_servers: Array<string>;
  resource: string;
};

/** @internal */
export const ResourceMetadata$outboundSchema: z.ZodMiniType<
  ResourceMetadata$Outbound,
  ResourceMetadata
> = z.pipe(
  z.object({
    authorizationServers: z.array(z.string()),
    resource: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      authorizationServers: "authorization_servers",
    });
  }),
);

export function resourceMetadataToJSON(
  resourceMetadata: ResourceMetadata,
): string {
  return JSON.stringify(
    ResourceMetadata$outboundSchema.parse(resourceMetadata),
  );
}

/** @internal */
export const PrepareEMARequestBodyTokenEndpointAuthMethod$outboundSchema:
  z.ZodMiniEnum<typeof PrepareEMARequestBodyTokenEndpointAuthMethod> = z.enum(
    PrepareEMARequestBodyTokenEndpointAuthMethod,
  );

/** @internal */
export type PrepareEMARequestBody$Outbound = {
  client_id?: string | undefined;
  confirm_grants?: Array<string> | undefined;
  expected_generation: number;
  mechanism: string;
  remote_session_issuer_id: string;
  resource: string;
  resource_metadata?: ResourceMetadata$Outbound | undefined;
  scopes?: Array<string> | undefined;
  token_endpoint_auth_method?: string | undefined;
  user_session_issuer_id: string;
};

/** @internal */
export const PrepareEMARequestBody$outboundSchema: z.ZodMiniType<
  PrepareEMARequestBody$Outbound,
  PrepareEMARequestBody
> = z.pipe(
  z.object({
    clientId: z.optional(z.string()),
    confirmGrants: z.optional(z.array(z.string())),
    expectedGeneration: z.int(),
    mechanism: z._default(Mechanism$outboundSchema, "manual"),
    remoteSessionIssuerId: z.string(),
    resource: z.string(),
    resourceMetadata: z.optional(z.lazy(() => ResourceMetadata$outboundSchema)),
    scopes: z.optional(z.array(z.string())),
    tokenEndpointAuthMethod: z.optional(
      PrepareEMARequestBodyTokenEndpointAuthMethod$outboundSchema,
    ),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientId: "client_id",
      confirmGrants: "confirm_grants",
      expectedGeneration: "expected_generation",
      remoteSessionIssuerId: "remote_session_issuer_id",
      resourceMetadata: "resource_metadata",
      tokenEndpointAuthMethod: "token_endpoint_auth_method",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function prepareEMARequestBodyToJSON(
  prepareEMARequestBody: PrepareEMARequestBody,
): string {
  return JSON.stringify(
    PrepareEMARequestBody$outboundSchema.parse(prepareEMARequestBody),
  );
}
